module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAASklEQVQ4y2P4jwQ+MAww7wADDNgPCh5EaDDwmEEh9GdQ8Pj//2ew/w8iBgHvDwOyywaaBwTM/wcDD8RgQE49A8kb6FyM4A2esg4Acku1K3vRGmUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDgtMTNUMTU6Mjc6MDgrMDk6MDAQgurLAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDEzLTEwLTA4VDA2OjA4OjIyKzA5OjAwP6gozQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_00605_100x100.png
// module id = 8xkA
// module chunks = 0